export default {
  editTitle: 'Edit Custom Model',
  newTitle: 'New Custom Model',
  create: 'Create',
  save: 'Save',
  warning: 'Warning',
  saveWarningMessage: 'Saving changes will delete all simulations for this model, and will delete and reprocess the Model Report.',
  cannotBeUndone: 'This action cannot be undone. Are you sure?',
  abort: 'Abort',
  confirm: 'Confirm',
  creatingCustomModel: 'Creating Custom Model...',
  search: 'Search',
  select: 'Select',
  close: 'Close',
  modelName: 'Model Name',
  country: 'Country',
  countryTooltip: 'Country for which the Custom Model will be created',
  referenceType: 'Reference type',
  ekrmReference: 'Expert Knowledge Reference Model',
  standardReference: 'Standard Reference Model',
  category: 'Category',
  categoryTooltip: 'Reference category that will be used to create the Custom Model',
  referenceBrands: 'Reference Brands',
  referenceBrandsTooltip: 'Reference brand within the selected category upon which the Custom Model will be created',
  modelStartDate: 'Model Start date',
  modelStartDateTooltip: 'Initial date for the Custom Model. This will be the starting point for the model report, and will determine how far into the future different simulations/optimizations can be made.',
  sales: 'Sales',
  averageMonthlySales: 'Average Monthly Sales',
  averageMonthlySalesTooltip: 'Average monthly revenue (in USD) of the target brand for which this Custom Model will be created. Properly defining this value will ensure a better match between the Reference Model and the Custom Model being created.',
  usdPerUnit: 'USD per Unit',
  usdPerUnitTooltip: 'When the corresponding Reference Model is modeled with a KPI value in units sold (instead of revenue), this conversion parameter is required to transform those units sold into revenue for the target brand.',
  spendAndAttribution: 'Spend & Attribution',
  spendAndAttributionTooltip: 'These are the different average monthly spends and the average contribution to sales of Own Controllable Spend (the portion of media spend that is fully controllable by the brand), Co-Marketing Spend (the portion of media that is not targeted specifically at the brand/product, but indirectly affects its results) and Competition Media Spend (how much, as an aggregate monthly total, direct/relevant competitors in the category are spending)',
  avgMonthlyOwnSpend: 'Average Monthly Own Controllable Spend',
  salesAttributedToOwnMedia: 'Sales Attributed to Own Controllable Media',
  avgMonthlyComarketingSpend: 'Average Monthly Co-Marketing Spend',
  salesAttributedToComarketing: 'Sales Attributed to Co-Marketing',
  avgMonthlyCompetitionSpend: 'Average Monthly Competition Spend',
  avgMonthlyCompetitionSales: 'Average Monthly Competition Sales',
  salesAttributedToCompetitionMedia: 'Sales Attributed to Competition Media',
  salesAttributedToCompetitionSales: 'Sales Attributed to Competition Sales',
  averageMediaMix: 'Average Media Mix',
  averageMediaMixTooltip: 'Average distribution of spend across all the different media channels. While this mix can be dynamic over time, those variations are defined in the Reference Model, whereas this input serves the purpose of properly scaling the mix to that of the target brand.',
  channelAttributionError: 'Sum of all channels should be 100%, not {total}%',
  seasonality: 'Seasonality',
  periodicBoostingEffect: 'Periodic/Cyclic Boosting Effect on Sales (%)',
  periodicBoostingInfo: 'This number represents a "boost" (multiplier) effect on sales due to a specific periodic/cyclic event, namely seasonal events that normally repeat year after year. For example, a value of 130% means that sales during that period will be "boosted" by 30% compared to a normal period.',
  spotEventsBoostingEffect: 'Spot Events Boosting Effect on Sales (%)',
  spotEventsBoostingInfo: 'Spot events are those that only happen during the month but are expected to repeat every year, for example Cyber Days, Black Friday, Mother\'s Day, etc. Just like with Periodic events, these values are "booster" (multiplier) effects on sales.',
  required: 'Required',
  mustBeGreaterThanZero: 'Must be greater than 0',
  selectEkrmCategory: 'Select EKRM Category',
  selectStandardCategory: 'Select Standard Reference Model Category',
  categoryName: 'Category Name',
  dateCreated: 'Date Created',
  createdBy: 'Created By'
}
